import {
  UpArrowGreen_Trend,
  UpArrowRed_Trend,
  UpArrowYellow_Trend,
} from 'assets/icons';
import { LinkProps } from 'next/link';
import CustomLink from 'components/shared/CustomLink';
import { FoodSpikeType, MealType, TimeToMealMap } from './types';
import { FoodScoreComponent } from './FoodScoreComponent';
import styles from './FoodListElement.module.css';

export const getSpikeIndicatorIcon = (
  input: FoodSpikeType,
  { className, style }: { className?: string; style?: React.CSSProperties },
) => {
  switch (input) {
    case 'high':
      return <UpArrowRed_Trend className={className} style={style} />;
    case 'medium':
      return <UpArrowYellow_Trend className={className} style={style} />;
    case 'stable':
      return <UpArrowGreen_Trend className={className} style={style} />;
    case 'low':
      return <UpArrowGreen_Trend className={className} style={style} />;
    default:
      return null;
  }
};

export const FoodListElement = (
  props: LinkProps & {
    foodTitle: string;
    foodScore: number;
    foodPeakValue: number;
    foodSpikeTrend?: string;
    mealTime?: MealType;
  },
) => {
  return (
    <CustomLink {...props} className={styles.root}>
      <div className={styles.foodTextContent}>
        <h5>{props.foodTitle}</h5>
        <p>
          {props.foodSpikeTrend ? (
            <>
              {getSpikeIndicatorIcon(props.foodSpikeTrend as FoodSpikeType, {})}
              <b>{Number(props.foodPeakValue).toFixed(0)} mg/dL</b> • Avg.
              glucose peak
            </>
          ) : null}
          {' • '}{' '}
          {props.mealTime ? <>{TimeToMealMap[props.mealTime].title}</> : null}
        </p>
      </div>
      <FoodScoreComponent
        value={Number(props.foodScore.toFixed(0))}
        className={styles.foodScoreElement}
      />
    </CustomLink>
  );
};
